export default "dist/images/block-feature-half.2d8d61b.png";